<template>
  <!-- 顶部右侧按钮 -->
  <div class="pc-contact">
    <div class="rect-btn contact-btn flc">
      联系我们
    </div>
    <div class="rect-btn phone-btn flc">
      <img class="contact-icon phoneicon" :src="phoneicon" />
      <div class="contact-txt">
        电话
      </div>
      <div class="expend">
        15618810120
      </div>
    </div>
    <div class="rect-btn wechat-btn flc">
      <img class="contact-icon weicon" :src="qricon" />
      <div class="contact-txt">
        微信
      </div>
      <div class="expend">
          <img class="qrcode-img" :src="qr" />
      </div>
    </div>
  </div>
</template>

<script>
const qricon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/qricon.png'
const phoneicon = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/phoneicon.png'
const qr = 'https://examonlinebj.oss-cn-beijing.aliyuncs.com/webgw/image/qr.png'
export default {
  name: 'pc-contact',
  props: {
  },
  data () {
    return {
      qricon,
      phoneicon,
      qr
    }
  }
}
</script>

<style scoped lang="scss">
.pc-contact {
  position: fixed;
  bottom: 60px;
  right: 12px;
  z-index: 1999;
  .rect-btn {
    width: 60px;
    height: 68px;
    background-color: #fff;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    z-index: 1;
    cursor: pointer;
    box-sizing: border-box;
    &.contact-btn {
      width: 60px;
      height: 60px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 24px;
      background-color: #5475FF;
      padding: 0 5px;
      box-sizing: border-box;
      text-align: center;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    &.phone-btn {
      position: relative;
      z-index: 2;
      &:after {
        content: '';
        display: block;
        left: 3px;
        right: 3px;
        height: 1px;
        background-color: #C5C5C5;
        left: 3px;
        bottom: 0;
        position: absolute;
      }
      flex-direction: column;
      padding-top: 5px;
    }
    &.wechat-btn {
      flex-direction: column;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      height: 74px;
      padding-top: 10px;
    }
    .contact-icon {
      width: 42px;
      height: 38px;
      &.phoneicon {
        height: 34px;
      }
      &.weicon {
      }
    }
    .contact-txt {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      color: #252525;
      line-height: 14px;
      margin-top: 4px;
    }
    &:hover {
      .expend {
        opacity: 1;
        transform: translate(0, 0) scale(1, 1);
      }
    }
    .expend {
      position: absolute;
      z-index: -1;
      right: 65px;
      background-color: #fff;
      bottom: 0;
      width: 150px;
      min-height: 66px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      opacity: 0;
      transform: translate(100%, 0);
      transition: all 0.3s ease;
      img {
        width: 120px;
        height: 120px;
      }
    }
  }
}
</style>
